import { render, staticRenderFns } from "./Riskfenlei.vue?vue&type=template&id=51ab4b98&scoped=true"
import script from "./Riskfenlei.vue?vue&type=script&lang=js"
export * from "./Riskfenlei.vue?vue&type=script&lang=js"
import style0 from "./Riskfenlei.vue?vue&type=style&index=0&id=51ab4b98&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ab4b98",
  null
  
)

export default component.exports